/* eslint-disable react/prop-types */
import { Stack } from '@mui/material';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import useLocales from '../../hooks/useLocales';
import { PATH_THIGPLX } from '../../routes/paths';

export function SituationHeader() {
  const { translate } = useLocales();

  const breadcrumbLinks = [
    { name: translate('menu.home'), href: PATH_THIGPLX.home },
    { name: translate('menu.situation'), href: PATH_THIGPLX.situations },
    { name: translate('wrongSituation.title') }
  ];

  return (
    <Stack direction={"row"} alignItems={"center"} >
      <HeaderBreadcrumbs
        heading={translate('wrongSituation.title')}
        links={breadcrumbLinks}
        subtitle={"Các tình huống bị điểm 0 khi làm đề thi"}
      />
    </Stack>
  );
}

